<template>
<body>
  <h1>Activation Required</h1>
  <p>Thank you for choosing XhibitSpaces! This screen has not yet been activated.</p>
  <p>Please speak with your administrator in order to activate the following Screen ID:</p>
  <div id="device_id">{{screenID}}</div>
  <p>This screen will automatically refresh upon activation.</p>
  <img
    src="../assets/mvix.png"
    alt="Mvix | Content Rich Digital Signage"
    class="logo"
    width="379"
    height="173"
  >
</body>
</template>

<script>
export default {
  props: ['screenID'],
};
</script>

<style lang="css" scoped>
#device_id {
  color: #1775b5;
  font-family: monospace;
  font-size: 36pt;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 24pt;
  text-align: center;
  padding: 24pt;
  margin: 1em auto;
  width: 12em;
  letter-spacing: 0.2em;
  text-transform: uppercase;
}

#device_id + p {
  text-align: center;
}

@media all and (min-width: 1820px) and (min-height: 980px) {
  #device_id {
    font-size: 48pt;
  }
}
body {
  background: #242524 url(../assets/activation_bg.png) no-repeat fixed;
  background-size: cover;
  color: #fff;
  font-family: sans-serif;
  font-size: 18pt;
  padding: 0.5in;
  background-repeat: no-repeat;
}

h1 {
  font-size: 36pt;
  font-weight: bold;
}

h2 {
  font-size: 24pt;
  font-weight: bold;
}

body:not(.error) .throbber::before {
  content: "";
  display: inline-block;
  /* background-image: url('throbber.gif'); */
  background-size: contain;
  background-repeat: no-repeat;
  padding: 0.75em;
  vertical-align: middle;
  position: relative;
  left: -0.2em;
  top: -0.0625em;
}

hr {
  border: 1pt solid white;
  width: 75%;
  margin-left: 0;
}

a {
  color: #3971bb;
  text-decoration: inherit;
  font-weight: bold;
}

.logo {
  position: fixed;
  bottom: 0.5in;
  left: calc(50% - 190px);
  transform: scale(0.5);
  text-align: center;
}

#status,
#datetime {
  color: #3971bb;
  font-size: 24pt;
  font-weight: lighter;
  font-style: italic;
}

@media all and (min-width: 1820px) and (min-height: 980px) {
  .logo {
    bottom: 1in;
    transform: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DeviceActivation.vue